import type {
  EncounterDischargeReasonCode,
  EncounterInvalidateReasonCode,
} from '@quromedical/fhir-common';
import type {
  AdmissionCreateResponse,
  AdmissionGetAllResponse,
  AdmissionGetParams,
  AdmissionUpdateRequest,
  AdmissionUpdateResponse,
  CreateAdmissionSchemaWithPatientInput,
} from '@quromedical/models/admission';

import type {
  MovePatientsToWardInput,
  MovePatientsToWardResponse,
} from '@quromedical/models/wards';
import { trpcClient } from 'trpc';

export const admissionSWRKey = 'trpc/admission';

export class AdmissionApi {
  public async updateAdmission(
    params: AdmissionUpdateRequest,
  ): Promise<AdmissionUpdateResponse> {
    const result = await trpcClient.admission.update.mutate(params);

    return result;
  }

  public getAdmissions = async (
    params: AdmissionGetParams,
  ): Promise<AdmissionGetAllResponse> => {
    return await trpcClient.admission.getAll.query({
      ...params,
    });
  };

  public async dischargePatient(
    patientId: string,
    reason: EncounterDischargeReasonCode,
    periodEnd: string,
  ): Promise<void> {
    await trpcClient.admission.discharge.mutate({
      id: patientId,
      statusReason: reason,
      periodEnd,
    });
  }

  public async moveAdmissionsToWard(
    params: MovePatientsToWardInput,
  ): Promise<MovePatientsToWardResponse> {
    const result =
      await trpcClient.admission.moveAdmissionsToWard.mutate(params);

    return result;
  }

  public async invalidateAdmission(
    admissionId: string,
    reason: EncounterInvalidateReasonCode,
  ): Promise<void> {
    await trpcClient.admission.invalidate.mutate({
      id: admissionId,
      statusReason: reason,
    });
  }

  public async createAdmission(
    params: CreateAdmissionSchemaWithPatientInput,
  ): Promise<AdmissionCreateResponse> {
    const result = await trpcClient.admission.create.mutate(params);

    return result;
  }

  public async startPlannedAdmission(
    admissionId: string,
    periodStart: string,
  ): Promise<AdmissionCreateResponse> {
    const result = await trpcClient.admission.start.mutate({
      id: admissionId,
      periodStart,
    });

    return result;
  }
}
